/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Consumer API Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export enum AlertCode {
    LowRed = 'LowRed',
    LowYellow = 'LowYellow',
    Green = 'Green',
    HighYellow = 'HighYellow',
    HighRed = 'HighRed'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum AnswerType {
    Single = 'Single',
    Multiple = 'Multiple',
    FreeText = 'FreeText'
}

/**
 * 
 * @export
 * @interface AppMaintenance
 */
export interface AppMaintenance {
    /**
     * 
     * @type {boolean}
     * @memberof AppMaintenance
     */
    'isMaintenance'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppMaintenance
     */
    'downtime'?: string;
}
/**
 * 
 * @export
 * @interface AppVersion
 */
export interface AppVersion {
    /**
     * 
     * @type {ReleaseVersion}
     * @memberof AppVersion
     */
    'android'?: ReleaseVersion;
    /**
     * 
     * @type {ReleaseVersion}
     * @memberof AppVersion
     */
    'ios'?: ReleaseVersion;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CareEpisodeProgramStatus {
    Active = 'Active',
    OnHold = 'OnHold',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum CareEpisodeStatus {
    Active = 'Active',
    Draft = 'Draft',
    OnHold = 'OnHold',
    Completed = 'Completed'
}

/**
 * 
 * @export
 * @interface ChatSessionMessage
 */
export interface ChatSessionMessage {
    /**
     * 
     * @type {ChatbotUserType}
     * @memberof ChatSessionMessage
     */
    'senderType'?: ChatbotUserType;
    /**
     * 
     * @type {string}
     * @memberof ChatSessionMessage
     */
    'senderDisplayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatSessionMessage
     */
    'senderId'?: string | null;
    /**
     * 
     * @type {ChatbotReferenceIdType}
     * @memberof ChatSessionMessage
     */
    'senderIdType'?: ChatbotReferenceIdType;
    /**
     * 
     * @type {string}
     * @memberof ChatSessionMessage
     */
    'messageBody'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatSessionMessage
     */
    'sentOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatSessionMessage
     */
    'guid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChatSessionMessage
     */
    'displaySequence'?: number;
}
/**
 * 
 * @export
 * @interface ChatSessionResponse
 */
export interface ChatSessionResponse {
    /**
     * 
     * @type {string}
     * @memberof ChatSessionResponse
     */
    'patientGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatSessionResponse
     */
    'programCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatSessionResponse
     */
    'referenceId'?: string | null;
    /**
     * 
     * @type {ChatbotInitialBy}
     * @memberof ChatSessionResponse
     */
    'initiatedBy'?: ChatbotInitialBy;
    /**
     * 
     * @type {ChatbotSessionType}
     * @memberof ChatSessionResponse
     */
    'sessionType'?: ChatbotSessionType;
    /**
     * 
     * @type {ChatbotStatus}
     * @memberof ChatSessionResponse
     */
    'status'?: ChatbotStatus;
    /**
     * 
     * @type {string}
     * @memberof ChatSessionResponse
     */
    'guid'?: string | null;
    /**
     * 
     * @type {Array<ChatSessionUser>}
     * @memberof ChatSessionResponse
     */
    'users'?: Array<ChatSessionUser> | null;
    /**
     * 
     * @type {Array<ChatSessionMessage>}
     * @memberof ChatSessionResponse
     */
    'messages'?: Array<ChatSessionMessage> | null;
    /**
     * 
     * @type {ChatbotOutcome}
     * @memberof ChatSessionResponse
     */
    'outcomeType'?: ChatbotOutcome;
}
/**
 * 
 * @export
 * @interface ChatSessionUser
 */
export interface ChatSessionUser {
    /**
     * 
     * @type {ChatbotUserType}
     * @memberof ChatSessionUser
     */
    'userType'?: ChatbotUserType;
    /**
     * 
     * @type {string}
     * @memberof ChatSessionUser
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatSessionUser
     */
    'referenceId'?: string | null;
    /**
     * 
     * @type {ChatbotReferenceIdType}
     * @memberof ChatSessionUser
     */
    'referenceIdType'?: ChatbotReferenceIdType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ChatbotInitialBy {
    EventServer = 'EventServer',
    Patient = 'Patient',
    Clinician = 'Clinician'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ChatbotOutcome {
    None = 'None',
    AlertCreated = 'AlertCreated',
    AlertResolved = 'AlertResolved',
    EventingPaused = 'EventingPaused',
    ReminderSet = 'ReminderSet',
    OverseaseSet = 'OverseaseSet',
    MissedReadingCreated = 'MissedReadingCreated',
    ContactPatientCreated = 'ContactPatientCreated',
    PreCallSurveyCreated = 'PreCallSurveyCreated',
    Error = 'Error',
    CreateContactPatientandMissedReadingCreated = 'CreateContactPatientandMissedReadingCreated'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ChatbotReferenceIdType {
    Guid = 'Guid',
    ProgramCode = 'ProgramCode',
    BotName = 'BotName'
}

/**
 * 
 * @export
 * @interface ChatbotSessionEnquiryRequest
 */
export interface ChatbotSessionEnquiryRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatbotSessionEnquiryRequest
     */
    'programCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatbotSessionEnquiryRequest
     */
    'referenceId'?: string | null;
    /**
     * 
     * @type {ChatbotInitialBy}
     * @memberof ChatbotSessionEnquiryRequest
     */
    'initiatedBy'?: ChatbotInitialBy;
    /**
     * 
     * @type {number}
     * @memberof ChatbotSessionEnquiryRequest
     */
    'expiration'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatbotSessionEnquiryRequest
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ChatbotSessionType {
    ContactPatient = 'ContactPatient',
    MissedReading = 'MissedReading',
    PreCallSurvey = 'PreCallSurvey',
    SmokingDetails = 'SmokingDetails'
}

/**
 * 
 * @export
 * @interface ChatbotSetting
 */
export interface ChatbotSetting {
    /**
     * 
     * @type {string}
     * @memberof ChatbotSetting
     */
    'guid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatbotSetting
     */
    'directlineToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatbotSetting
     */
    'programCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatbotSetting
     */
    'botUILink'?: string | null;
    /**
     * 
     * @type {ChatbotType}
     * @memberof ChatbotSetting
     */
    'botType'?: ChatbotType;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ChatbotStatus {
    Created = 'CREATED',
    Completed = 'COMPLETED',
    Expired = 'EXPIRED'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ChatbotType {
    Generic = 'Generic',
    QnA = 'QnA'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ChatbotUserType {
    Bot = 'BOT',
    Patient = 'PATIENT',
    Clinician = 'CLINICIAN'
}

/**
 * 
 * @export
 * @interface CompositeFilterCriteria
 */
export interface CompositeFilterCriteria {
    /**
     * 
     * @type {string}
     * @memberof CompositeFilterCriteria
     */
    'filterType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompositeFilterCriteria
     */
    'isNegated'?: boolean;
    /**
     * 
     * @type {CriteriaCondition}
     * @memberof CompositeFilterCriteria
     */
    'condition'?: CriteriaCondition;
    /**
     * 
     * @type {Array<SingleFilterCriteria>}
     * @memberof CompositeFilterCriteria
     */
    'criterias'?: Array<SingleFilterCriteria> | null;
}
/**
 * 
 * @export
 * @interface ConsentAgreementRequest
 */
export interface ConsentAgreementRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ConsentAgreementRequest
     */
    'consentGuids'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ConsentCheckResponse
 */
export interface ConsentCheckResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ConsentCheckResponse
     */
    'hasPending'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ConsentCheckResponse
     */
    'noOfPendingConsents'?: number;
}
/**
 * 
 * @export
 * @interface ConsentResponse
 */
export interface ConsentResponse {
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    'guid'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConsentResponse
     */
    'version'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    'header'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConsentResponse
     */
    'content'?: string | null;
}
/**
 * 
 * @export
 * @interface ConsumerUserProfileResponse
 */
export interface ConsumerUserProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof ConsumerUserProfileResponse
     */
    'userGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsumerUserProfileResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConsumerUserProfileResponse
     */
    'institutionGuid'?: string;
    /**
     * 
     * @type {Language}
     * @memberof ConsumerUserProfileResponse
     */
    'language'?: Language;
    /**
     * 
     * @type {string}
     * @memberof ConsumerUserProfileResponse
     */
    'locationGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsumerUserProfileResponse
     */
    'patientGuid'?: string;
    /**
     * 
     * @type {PatientStatus}
     * @memberof ConsumerUserProfileResponse
     */
    'patientStatus'?: PatientStatus;
    /**
     * 
     * @type {string}
     * @memberof ConsumerUserProfileResponse
     */
    'careEpisodeGuid'?: string | null;
    /**
     * 
     * @type {CareEpisodeStatus}
     * @memberof ConsumerUserProfileResponse
     */
    'careEpisodeStatus'?: CareEpisodeStatus;
    /**
     * 
     * @type {string}
     * @memberof ConsumerUserProfileResponse
     */
    'programCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConsumerUserProfileResponse
     */
    'careEpisodeProgramGuid'?: string | null;
    /**
     * 
     * @type {CareEpisodeProgramStatus}
     * @memberof ConsumerUserProfileResponse
     */
    'careEpisodeProgramStatus'?: CareEpisodeProgramStatus;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CriteriaCondition {
    And = 'And',
    Or = 'Or'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum DayOfWeek {
    Sunday = 'Sunday',
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday'
}

/**
 * 
 * @export
 * @interface DeviceRegistration
 */
export interface DeviceRegistration {
    /**
     * 
     * @type {string}
     * @memberof DeviceRegistration
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceRegistration
     */
    'deviceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceRegistration
     */
    'deviceOsVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceRegistration
     */
    'deviceManufacturer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceRegistration
     */
    'deviceModel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceRegistration
     */
    'deviceToken'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceRegistration
     */
    'platform'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EntryMode {
    Manual = 'Manual',
    Auto = 'Auto'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum FilterOperator {
    LessThan = 'LessThan',
    LessThanOrEqual = 'LessThanOrEqual',
    GreaterThanOrEqual = 'GreaterThanOrEqual',
    GreaterThan = 'GreaterThan',
    Equal = 'Equal',
    NotEqual = 'NotEqual',
    StartsWith = 'StartsWith',
    EndsWith = 'EndsWith',
    Contains = 'Contains',
    NotContains = 'NotContains',
    In = 'In',
    NotIn = 'NotIn'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum Language {
    En = 'EN',
    Zh = 'ZH',
    Ms = 'MS',
    Ta = 'TA',
    Bn = 'BN'
}

/**
 * 
 * @export
 * @interface MeasuringGroupResponse
 */
export interface MeasuringGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof MeasuringGroupResponse
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeasuringGroupResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeasuringGroupResponse
     */
    'displaySequence'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MeasuringGroupResponse
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeasuringGroupResponse
     */
    'guid'?: string;
    /**
     * 
     * @type {Array<MeasuringTypeResponse>}
     * @memberof MeasuringGroupResponse
     */
    'measuringTypes'?: Array<MeasuringTypeResponse> | null;
}
/**
 * 
 * @export
 * @interface MeasuringTypeResponse
 */
export interface MeasuringTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof MeasuringTypeResponse
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeasuringTypeResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeasuringTypeResponse
     */
    'displaySequence'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MeasuringTypeResponse
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeasuringTypeResponse
     */
    'guid'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeasuringTypeResponse
     */
    'group'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeasuringTypeResponse
     */
    'unitCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeasuringTypeResponse
     */
    'unitName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeasuringTypeResponse
     */
    'min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeasuringTypeResponse
     */
    'max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeasuringTypeResponse
     */
    'decimalPlaces'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationActionStatus {
    NoAction = 'NoAction',
    Pending = 'Pending',
    Completed = 'Completed',
    Expired = 'Expired'
}

/**
 * 
 * @export
 * @interface NotificationActionStatusUpdateRequest
 */
export interface NotificationActionStatusUpdateRequest {
    /**
     * 
     * @type {NotificationActionStatus}
     * @memberof NotificationActionStatusUpdateRequest
     */
    'status'?: NotificationActionStatus;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationInboxStatus {
    New = 'New',
    Seen = 'Seen',
    Removed = 'Removed'
}

/**
 * 
 * @export
 * @interface NotificationInboxStatusUpdateRequest
 */
export interface NotificationInboxStatusUpdateRequest {
    /**
     * 
     * @type {NotificationInboxStatus}
     * @memberof NotificationInboxStatusUpdateRequest
     */
    'status'?: NotificationInboxStatus;
}
/**
 * 
 * @export
 * @interface NotificationMessage
 */
export interface NotificationMessage {
    /**
     * 
     * @type {string}
     * @memberof NotificationMessage
     */
    'guid'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMessage
     */
    'patientGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationMessage
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMessage
     */
    'message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMessage
     */
    'messageFull'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationMessage
     */
    'sentOn'?: string;
    /**
     * 
     * @type {NotificationInboxStatus}
     * @memberof NotificationMessage
     */
    'inboxStatus'?: NotificationInboxStatus;
    /**
     * 
     * @type {NotificationActionStatus}
     * @memberof NotificationMessage
     */
    'actionStatus'?: NotificationActionStatus;
    /**
     * 
     * @type {NotificationStatus}
     * @memberof NotificationMessage
     */
    'status'?: NotificationStatus;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof NotificationMessage
     */
    'properties'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface NotificationMessagePagination
 */
export interface NotificationMessagePagination {
    /**
     * 
     * @type {number}
     * @memberof NotificationMessagePagination
     */
    'totalRecords'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationMessagePagination
     */
    'currentPageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationMessagePagination
     */
    'totalPage'?: number;
    /**
     * 
     * @type {Array<NotificationMessage>}
     * @memberof NotificationMessagePagination
     */
    'items'?: Array<NotificationMessage> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationStatus {
    Pending = 'Pending',
    Past = 'Past'
}

/**
 * 
 * @export
 * @interface ObservationSubmissionChartRequest
 */
export interface ObservationSubmissionChartRequest {
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionChartRequest
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionChartRequest
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface ObservationSubmissionOutcome
 */
export interface ObservationSubmissionOutcome {
    /**
     * 
     * @type {AlertCode}
     * @memberof ObservationSubmissionOutcome
     */
    'alertCode'?: AlertCode;
    /**
     * 
     * @type {OutcomeIcon}
     * @memberof ObservationSubmissionOutcome
     */
    'outcomeIcon'?: OutcomeIcon;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionOutcome
     */
    'outcomeCode'?: string | null;
}
/**
 * 
 * @export
 * @interface ObservationSubmissionResponse
 */
export interface ObservationSubmissionResponse {
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionResponse
     */
    'guid'?: string;
    /**
     * 
     * @type {SubmissionType}
     * @memberof ObservationSubmissionResponse
     */
    'submissionType'?: SubmissionType;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionResponse
     */
    'scheduledSubmissionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionResponse
     */
    'submissionTimeUtc'?: string;
    /**
     * 
     * @type {Source}
     * @memberof ObservationSubmissionResponse
     */
    'source'?: Source;
    /**
     * 
     * @type {number}
     * @memberof ObservationSubmissionResponse
     */
    'submissionNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionResponse
     */
    'patientGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionResponse
     */
    'careEpisodeGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionResponse
     */
    'institutionGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionResponse
     */
    'locationGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionResponse
     */
    'sessionId'?: string;
    /**
     * 
     * @type {Array<ObservationValueResponse>}
     * @memberof ObservationSubmissionResponse
     */
    'values'?: Array<ObservationValueResponse> | null;
}
/**
 * 
 * @export
 * @interface ObservationSubmissionResponsePagination
 */
export interface ObservationSubmissionResponsePagination {
    /**
     * 
     * @type {number}
     * @memberof ObservationSubmissionResponsePagination
     */
    'totalRecords'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSubmissionResponsePagination
     */
    'currentPageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSubmissionResponsePagination
     */
    'totalPage'?: number;
    /**
     * 
     * @type {Array<ObservationSubmissionResponse>}
     * @memberof ObservationSubmissionResponsePagination
     */
    'items'?: Array<ObservationSubmissionResponse> | null;
}
/**
 * 
 * @export
 * @interface ObservationSubmissionSaveRequest
 */
export interface ObservationSubmissionSaveRequest {
    /**
     * 
     * @type {SubmissionType}
     * @memberof ObservationSubmissionSaveRequest
     */
    'submissionType'?: SubmissionType;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionSaveRequest
     */
    'submissionTimeUtc'?: string | null;
    /**
     * 
     * @type {Source}
     * @memberof ObservationSubmissionSaveRequest
     */
    'source'?: Source;
    /**
     * 
     * @type {Array<ObservationValueSaveRequest>}
     * @memberof ObservationSubmissionSaveRequest
     */
    'values'?: Array<ObservationValueSaveRequest> | null;
}
/**
 * 
 * @export
 * @interface ObservationSubmissionSearchRequest
 */
export interface ObservationSubmissionSearchRequest {
    /**
     * 
     * @type {number}
     * @memberof ObservationSubmissionSearchRequest
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSubmissionSearchRequest
     */
    'pageSize'?: number;
    /**
     * 
     * @type {CompositeFilterCriteria}
     * @memberof ObservationSubmissionSearchRequest
     */
    'criteria'?: CompositeFilterCriteria;
    /**
     * 
     * @type {Array<SortDescriptor>}
     * @memberof ObservationSubmissionSearchRequest
     */
    'sorts'?: Array<SortDescriptor> | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionSearchRequest
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionSearchRequest
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface ObservationSubmissionStatisticRequest
 */
export interface ObservationSubmissionStatisticRequest {
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionStatisticRequest
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservationSubmissionStatisticRequest
     */
    'endDate'?: string;
    /**
     * 
     * @type {Recurrence}
     * @memberof ObservationSubmissionStatisticRequest
     */
    'recurrance'?: Recurrence;
}
/**
 * 
 * @export
 * @interface ObservationSubmissionStatisticResponse
 */
export interface ObservationSubmissionStatisticResponse {
    /**
     * 
     * @type {number}
     * @memberof ObservationSubmissionStatisticResponse
     */
    'year'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSubmissionStatisticResponse
     */
    'month'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ObservationSubmissionStatisticResponse
     */
    'day'?: number | null;
    /**
     * 
     * @type {Array<ObservationValueStatisticResponse>}
     * @memberof ObservationSubmissionStatisticResponse
     */
    'values'?: Array<ObservationValueStatisticResponse> | null;
}
/**
 * 
 * @export
 * @interface ObservationValueResponse
 */
export interface ObservationValueResponse {
    /**
     * 
     * @type {string}
     * @memberof ObservationValueResponse
     */
    'guid'?: string;
    /**
     * 
     * @type {EntryMode}
     * @memberof ObservationValueResponse
     */
    'entryMode'?: EntryMode;
    /**
     * 
     * @type {number}
     * @memberof ObservationValueResponse
     */
    'value'?: number;
    /**
     * 
     * @type {AlertCode}
     * @memberof ObservationValueResponse
     */
    'alertCode'?: AlertCode;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueResponse
     */
    'measuringTypeGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueResponse
     */
    'measuringTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueResponse
     */
    'measuringTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueResponse
     */
    'measuringTypeUom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueResponse
     */
    'measuringTypeGroupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueResponse
     */
    'measuringTypeGroupCode'?: string | null;
}
/**
 * 
 * @export
 * @interface ObservationValueSaveRequest
 */
export interface ObservationValueSaveRequest {
    /**
     * 
     * @type {EntryMode}
     * @memberof ObservationValueSaveRequest
     */
    'entryMode'?: EntryMode;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueSaveRequest
     */
    'measuringTypeCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ObservationValueSaveRequest
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface ObservationValueStatisticResponse
 */
export interface ObservationValueStatisticResponse {
    /**
     * 
     * @type {string}
     * @memberof ObservationValueStatisticResponse
     */
    'measuringTypeGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueStatisticResponse
     */
    'measuringTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueStatisticResponse
     */
    'measuringTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueStatisticResponse
     */
    'measuringTypeUom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueStatisticResponse
     */
    'measuringTypeGroupName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationValueStatisticResponse
     */
    'measuringTypeGroupCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ObservationValueStatisticResponse
     */
    'low'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationValueStatisticResponse
     */
    'high'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationValueStatisticResponse
     */
    'average'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationValueStatisticResponse
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum OutcomeIcon {
    Default = 'Default',
    None = 'None',
    Sad = 'Sad',
    Happy = 'Happy',
    Neutral = 'Neutral'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum PatientStatus {
    Draft = 'Draft',
    Active = 'Active',
    Inactive = 'Inactive',
    Recovered = 'Recovered'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum Recurrence {
    Day = 'Day',
    Week = 'Week',
    BiWeekly = 'BiWeekly',
    Month = 'Month',
    Year = 'Year'
}

/**
 * 
 * @export
 * @interface ReleaseVersion
 */
export interface ReleaseVersion {
    /**
     * 
     * @type {number}
     * @memberof ReleaseVersion
     */
    'min'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReleaseVersion
     */
    'current'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReleaseVersion
     */
    'packageId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReleaseVersion
     */
    'downloadUrl'?: string | null;
}
/**
 * 
 * @export
 * @interface ReminderPattern
 */
export interface ReminderPattern {
    /**
     * 
     * @type {RepeatPatternType}
     * @memberof ReminderPattern
     */
    'type'?: RepeatPatternType;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof ReminderPattern
     */
    'dayOfWeek'?: DayOfWeek;
    /**
     * 
     * @type {TimeSpan}
     * @memberof ReminderPattern
     */
    'scheduledTime'?: TimeSpan;
    /**
     * 
     * @type {number}
     * @memberof ReminderPattern
     */
    'timeZoneOffset'?: number | null;
}
/**
 * 
 * @export
 * @interface ReminderResponse
 */
export interface ReminderResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ReminderResponse
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReminderResponse
     */
    'content'?: string | null;
    /**
     * 
     * @type {Array<ReminderPattern>}
     * @memberof ReminderResponse
     */
    'reminderPatterns'?: Array<ReminderPattern> | null;
    /**
     * 
     * @type {string}
     * @memberof ReminderResponse
     */
    'guid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReminderResponse
     */
    'patientGuid'?: string | null;
}
/**
 * 
 * @export
 * @interface ReminderSaveRequest
 */
export interface ReminderSaveRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ReminderSaveRequest
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReminderSaveRequest
     */
    'content'?: string | null;
    /**
     * 
     * @type {Array<ReminderPattern>}
     * @memberof ReminderSaveRequest
     */
    'reminderPatterns'?: Array<ReminderPattern> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum RepeatPatternType {
    Daily = 'Daily',
    Weekly = 'Weekly'
}

/**
 * 
 * @export
 * @interface SearchCriteria
 */
export interface SearchCriteria {
    /**
     * 
     * @type {number}
     * @memberof SearchCriteria
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchCriteria
     */
    'pageSize'?: number;
    /**
     * 
     * @type {CompositeFilterCriteria}
     * @memberof SearchCriteria
     */
    'criteria'?: CompositeFilterCriteria;
    /**
     * 
     * @type {Array<SortDescriptor>}
     * @memberof SearchCriteria
     */
    'sorts'?: Array<SortDescriptor> | null;
}
/**
 * 
 * @export
 * @interface SingleFilterCriteria
 */
export interface SingleFilterCriteria {
    /**
     * 
     * @type {string}
     * @memberof SingleFilterCriteria
     */
    'filterType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SingleFilterCriteria
     */
    'isNegated'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SingleFilterCriteria
     */
    'field'?: string | null;
    /**
     * 
     * @type {FilterOperator}
     * @memberof SingleFilterCriteria
     */
    'operator'?: FilterOperator;
    /**
     * 
     * @type {any}
     * @memberof SingleFilterCriteria
     */
    'filterValue'?: any | null;
    /**
     * 
     * @type {any}
     * @memberof SingleFilterCriteria
     */
    'value'?: any | null;
}
/**
 * 
 * @export
 * @interface SortDescriptor
 */
export interface SortDescriptor {
    /**
     * 
     * @type {string}
     * @memberof SortDescriptor
     */
    'field'?: string | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof SortDescriptor
     */
    'direction'?: SortDirection;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum SortDirection {
    Asc = 'Asc',
    Desc = 'Desc'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum Source {
    Kiosk = 'Kiosk',
    PersonalDevice = 'PersonalDevice',
    Gpc = 'GPC',
    Custom = 'Custom',
    Ptec = 'PTEC',
    Hisg = 'HISG'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum SubmissionType {
    Manual = 'Manual',
    Scheduled = 'Scheduled'
}

/**
 * 
 * @export
 * @interface SurveySubmissionQuestionAnswerRequest
 */
export interface SurveySubmissionQuestionAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionAnswerRequest
     */
    'questionKey'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveySubmissionQuestionAnswerRequest
     */
    'answerKeys'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionAnswerRequest
     */
    'freeText'?: string | null;
}
/**
 * 
 * @export
 * @interface SurveySubmissionQuestionAnswerResponse
 */
export interface SurveySubmissionQuestionAnswerResponse {
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionAnswerResponse
     */
    'guid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionAnswerResponse
     */
    'answerKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionAnswerResponse
     */
    'answerGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionAnswerResponse
     */
    'answerDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionAnswerResponse
     */
    'answerSubText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionAnswerResponse
     */
    'answerValue'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SurveySubmissionQuestionAnswerResponse
     */
    'displaySequence'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SurveySubmissionQuestionAnswerResponse
     */
    'alertIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionAnswerResponse
     */
    'freeText'?: string | null;
}
/**
 * 
 * @export
 * @interface SurveySubmissionQuestionResponse
 */
export interface SurveySubmissionQuestionResponse {
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionResponse
     */
    'guid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionResponse
     */
    'questionGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionResponse
     */
    'questionKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionResponse
     */
    'questionDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionResponse
     */
    'questionSubText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionQuestionResponse
     */
    'questionValue'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SurveySubmissionQuestionResponse
     */
    'displaySequence'?: number | null;
    /**
     * 
     * @type {AnswerType}
     * @memberof SurveySubmissionQuestionResponse
     */
    'answerType'?: AnswerType;
    /**
     * 
     * @type {Array<SurveySubmissionQuestionAnswerResponse>}
     * @memberof SurveySubmissionQuestionResponse
     */
    'answers'?: Array<SurveySubmissionQuestionAnswerResponse> | null;
}
/**
 * 
 * @export
 * @interface SurveySubmissionRequest
 */
export interface SurveySubmissionRequest {
    /**
     * 
     * @type {Language}
     * @memberof SurveySubmissionRequest
     */
    'language'?: Language;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveySubmissionRequest
     */
    'keys'?: Array<string> | null;
    /**
     * 
     * @type {Array<SurveySubmissionQuestionAnswerRequest>}
     * @memberof SurveySubmissionRequest
     */
    'answers'?: Array<SurveySubmissionQuestionAnswerRequest> | null;
}
/**
 * 
 * @export
 * @interface SurveySubmissionResponse
 */
export interface SurveySubmissionResponse {
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionResponse
     */
    'guid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionResponse
     */
    'submissionGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionResponse
     */
    'surveyGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionResponse
     */
    'surveyKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionResponse
     */
    'surveyDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionResponse
     */
    'surveyValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveySubmissionResponse
     */
    'surveySubText'?: string | null;
    /**
     * 
     * @type {Array<SurveySubmissionQuestionResponse>}
     * @memberof SurveySubmissionResponse
     */
    'questions'?: Array<SurveySubmissionQuestionResponse> | null;
    /**
     * 
     * @type {number}
     * @memberof SurveySubmissionResponse
     */
    'totalScore'?: number;
}
/**
 * 
 * @export
 * @interface SurveyTemplateHeader
 */
export interface SurveyTemplateHeader {
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateHeader
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateHeader
     */
    'decription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateHeader
     */
    'displayValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateHeader
     */
    'subText'?: string | null;
}
/**
 * 
 * @export
 * @interface SurveyTemplateQuestionAnswerResponse
 */
export interface SurveyTemplateQuestionAnswerResponse {
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateQuestionAnswerResponse
     */
    'displayValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateQuestionAnswerResponse
     */
    'subText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateQuestionAnswerResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateQuestionAnswerResponse
     */
    'key'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SurveyTemplateQuestionAnswerResponse
     */
    'displaySequence'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SurveyTemplateQuestionAnswerResponse
     */
    'alertIndex'?: number;
}
/**
 * 
 * @export
 * @interface SurveyTemplateQuestionResponse
 */
export interface SurveyTemplateQuestionResponse {
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateQuestionResponse
     */
    'displayValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateQuestionResponse
     */
    'subText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateQuestionResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyTemplateQuestionResponse
     */
    'key'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyTemplateQuestionResponse
     */
    'isMandatory'?: boolean;
    /**
     * 
     * @type {AnswerType}
     * @memberof SurveyTemplateQuestionResponse
     */
    'answerType'?: AnswerType;
    /**
     * 
     * @type {number}
     * @memberof SurveyTemplateQuestionResponse
     */
    'displaySequence'?: number | null;
    /**
     * 
     * @type {Array<SurveyTemplateQuestionAnswerResponse>}
     * @memberof SurveyTemplateQuestionResponse
     */
    'answers'?: Array<SurveyTemplateQuestionAnswerResponse> | null;
}
/**
 * 
 * @export
 * @interface SurveyTemplateResponse
 */
export interface SurveyTemplateResponse {
    /**
     * 
     * @type {Language}
     * @memberof SurveyTemplateResponse
     */
    'language'?: Language;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyTemplateResponse
     */
    'keys'?: Array<string> | null;
    /**
     * 
     * @type {Array<SurveyTemplateHeader>}
     * @memberof SurveyTemplateResponse
     */
    'headers'?: Array<SurveyTemplateHeader> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyTemplateResponse
     */
    'canSkip'?: boolean;
    /**
     * 
     * @type {Array<SurveyTemplateQuestionResponse>}
     * @memberof SurveyTemplateResponse
     */
    'questions'?: Array<SurveyTemplateQuestionResponse> | null;
}
/**
 * 
 * @export
 * @interface ThresholdResponse
 */
export interface ThresholdResponse {
    /**
     * 
     * @type {ThresholdType}
     * @memberof ThresholdResponse
     */
    'thresholdType'?: ThresholdType;
    /**
     * 
     * @type {string}
     * @memberof ThresholdResponse
     */
    'referenceGuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThresholdResponse
     */
    'referenceName'?: string | null;
    /**
     * 
     * @type {Array<ThresholdValueResponse>}
     * @memberof ThresholdResponse
     */
    'values'?: Array<ThresholdValueResponse> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ThresholdType {
    System = 'System',
    Cluster = 'Cluster',
    Program = 'Program',
    Institution = 'Institution',
    ClinicalProgram = 'ClinicalProgram',
    Patient = 'Patient'
}

/**
 * 
 * @export
 * @interface ThresholdValueResponse
 */
export interface ThresholdValueResponse {
    /**
     * 
     * @type {ThresholdValueType}
     * @memberof ThresholdValueResponse
     */
    'thresholdValueType'?: ThresholdValueType;
    /**
     * 
     * @type {number}
     * @memberof ThresholdValueResponse
     */
    'lowRedLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdValueResponse
     */
    'lowYellowLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdValueResponse
     */
    'highYellowLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdValueResponse
     */
    'highRedLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ThresholdValueResponse
     */
    'measuringTypeGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThresholdValueResponse
     */
    'guid'?: string;
    /**
     * 
     * @type {ThresholdType}
     * @memberof ThresholdValueResponse
     */
    'thresholdType'?: ThresholdType;
    /**
     * 
     * @type {string}
     * @memberof ThresholdValueResponse
     */
    'referenceGuid'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ThresholdValueResponse
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThresholdValueResponse
     */
    'unitCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThresholdValueResponse
     */
    'unitName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdValueResponse
     */
    'min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdValueResponse
     */
    'max'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdValueResponse
     */
    'decimalPlaces'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThresholdValueResponse
     */
    'measuringTypeCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThresholdValueResponse
     */
    'measuringTypeName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ThresholdValueResponse
     */
    'measuringGroupName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ThresholdValueResponse
     */
    'displaySequence'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ThresholdValueType {
    Individual = 'Individual',
    MonthlyAvg = 'Monthly_AVG',
    WeeklyAvg = 'Weekly_AVG'
}

/**
 * 
 * @export
 * @interface TimeSpan
 */
export interface TimeSpan {
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    'ticks'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    'days'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    'hours'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    'milliseconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    'minutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    'seconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    'totalDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    'totalHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    'totalMilliseconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    'totalMinutes'?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeSpan
     */
    'totalSeconds'?: number;
}

/**
 * ChatbotApi - axios parameter creator
 * @export
 */
export const ChatbotApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ChatbotSessionEnquiryRequest} [chatbotSessionEnquiryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatbotsSessionsEnquiriesPost: async (chatbotSessionEnquiryRequest?: ChatbotSessionEnquiryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chatbots/sessions/enquiries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatbotSessionEnquiryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatbotsSettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chatbots/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatbotApi - functional programming interface
 * @export
 */
export const ChatbotApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatbotApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ChatbotSessionEnquiryRequest} [chatbotSessionEnquiryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatbotsSessionsEnquiriesPost(chatbotSessionEnquiryRequest?: ChatbotSessionEnquiryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatbotsSessionsEnquiriesPost(chatbotSessionEnquiryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatbotsSettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatbotSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatbotsSettingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChatbotApi - factory interface
 * @export
 */
export const ChatbotApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatbotApiFp(configuration)
    return {
        /**
         * 
         * @param {ChatbotSessionEnquiryRequest} [chatbotSessionEnquiryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatbotsSessionsEnquiriesPost(chatbotSessionEnquiryRequest?: ChatbotSessionEnquiryRequest, options?: any): AxiosPromise<ChatSessionResponse> {
            return localVarFp.chatbotsSessionsEnquiriesPost(chatbotSessionEnquiryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatbotsSettingsGet(options?: any): AxiosPromise<ChatbotSetting> {
            return localVarFp.chatbotsSettingsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatbotApi - object-oriented interface
 * @export
 * @class ChatbotApi
 * @extends {BaseAPI}
 */
export class ChatbotApi extends BaseAPI {
    /**
     * 
     * @param {ChatbotSessionEnquiryRequest} [chatbotSessionEnquiryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatbotApi
     */
    public chatbotsSessionsEnquiriesPost(chatbotSessionEnquiryRequest?: ChatbotSessionEnquiryRequest, options?: AxiosRequestConfig) {
        return ChatbotApiFp(this.configuration).chatbotsSessionsEnquiriesPost(chatbotSessionEnquiryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatbotApi
     */
    public chatbotsSettingsGet(options?: AxiosRequestConfig) {
        return ChatbotApiFp(this.configuration).chatbotsSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MaintenanceApi - axios parameter creator
 * @export
 */
export const MaintenanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMaintenanceGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/app/Maintenance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MaintenanceApi - functional programming interface
 * @export
 */
export const MaintenanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MaintenanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appMaintenanceGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppMaintenance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appMaintenanceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MaintenanceApi - factory interface
 * @export
 */
export const MaintenanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MaintenanceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMaintenanceGet(options?: any): AxiosPromise<AppMaintenance> {
            return localVarFp.appMaintenanceGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MaintenanceApi - object-oriented interface
 * @export
 * @class MaintenanceApi
 * @extends {BaseAPI}
 */
export class MaintenanceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MaintenanceApi
     */
    public appMaintenanceGet(options?: AxiosRequestConfig) {
        return MaintenanceApiFp(this.configuration).appMaintenanceGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DeviceRegistration} [deviceRegistration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsDeviceDeregisterPost: async (deviceRegistration?: DeviceRegistration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/device/deregister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceRegistration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeviceRegistration} [deviceRegistration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsDeviceRegisterAnonymousPost: async (deviceRegistration?: DeviceRegistration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/device/register/anonymous`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceRegistration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeviceRegistration} [deviceRegistration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsDeviceRegisterPost: async (deviceRegistration?: DeviceRegistration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/device/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceRegistration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {NotificationActionStatusUpdateRequest} [notificationActionStatusUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsMessagesIdActionStatusPost: async (id: string, notificationActionStatusUpdateRequest?: NotificationActionStatusUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('notificationsMessagesIdActionStatusPost', 'id', id)
            const localVarPath = `/notifications/messages/{id}/action/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationActionStatusUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {NotificationInboxStatusUpdateRequest} [notificationInboxStatusUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsMessagesIdInboxStatusPost: async (id: string, notificationInboxStatusUpdateRequest?: NotificationInboxStatusUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('notificationsMessagesIdInboxStatusPost', 'id', id)
            const localVarPath = `/notifications/messages/{id}/inbox/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationInboxStatusUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationStatus} status 
         * @param {SearchCriteria} [searchCriteria] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsMessagesStatusSearchPost: async (status: NotificationStatus, searchCriteria?: SearchCriteria, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('notificationsMessagesStatusSearchPost', 'status', status)
            const localVarPath = `/notifications/messages/{status}/search`
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchCriteria, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DeviceRegistration} [deviceRegistration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsDeviceDeregisterPost(deviceRegistration?: DeviceRegistration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsDeviceDeregisterPost(deviceRegistration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeviceRegistration} [deviceRegistration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsDeviceRegisterAnonymousPost(deviceRegistration?: DeviceRegistration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceRegistration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsDeviceRegisterAnonymousPost(deviceRegistration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DeviceRegistration} [deviceRegistration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsDeviceRegisterPost(deviceRegistration?: DeviceRegistration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceRegistration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsDeviceRegisterPost(deviceRegistration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {NotificationActionStatusUpdateRequest} [notificationActionStatusUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsMessagesIdActionStatusPost(id: string, notificationActionStatusUpdateRequest?: NotificationActionStatusUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsMessagesIdActionStatusPost(id, notificationActionStatusUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {NotificationInboxStatusUpdateRequest} [notificationInboxStatusUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsMessagesIdInboxStatusPost(id: string, notificationInboxStatusUpdateRequest?: NotificationInboxStatusUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsMessagesIdInboxStatusPost(id, notificationInboxStatusUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {NotificationStatus} status 
         * @param {SearchCriteria} [searchCriteria] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsMessagesStatusSearchPost(status: NotificationStatus, searchCriteria?: SearchCriteria, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationMessagePagination>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsMessagesStatusSearchPost(status, searchCriteria, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * 
         * @param {DeviceRegistration} [deviceRegistration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsDeviceDeregisterPost(deviceRegistration?: DeviceRegistration, options?: any): AxiosPromise<boolean> {
            return localVarFp.notificationsDeviceDeregisterPost(deviceRegistration, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeviceRegistration} [deviceRegistration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsDeviceRegisterAnonymousPost(deviceRegistration?: DeviceRegistration, options?: any): AxiosPromise<DeviceRegistration> {
            return localVarFp.notificationsDeviceRegisterAnonymousPost(deviceRegistration, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeviceRegistration} [deviceRegistration] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsDeviceRegisterPost(deviceRegistration?: DeviceRegistration, options?: any): AxiosPromise<DeviceRegistration> {
            return localVarFp.notificationsDeviceRegisterPost(deviceRegistration, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {NotificationActionStatusUpdateRequest} [notificationActionStatusUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsMessagesIdActionStatusPost(id: string, notificationActionStatusUpdateRequest?: NotificationActionStatusUpdateRequest, options?: any): AxiosPromise<NotificationMessage> {
            return localVarFp.notificationsMessagesIdActionStatusPost(id, notificationActionStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {NotificationInboxStatusUpdateRequest} [notificationInboxStatusUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsMessagesIdInboxStatusPost(id: string, notificationInboxStatusUpdateRequest?: NotificationInboxStatusUpdateRequest, options?: any): AxiosPromise<NotificationMessage> {
            return localVarFp.notificationsMessagesIdInboxStatusPost(id, notificationInboxStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationStatus} status 
         * @param {SearchCriteria} [searchCriteria] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsMessagesStatusSearchPost(status: NotificationStatus, searchCriteria?: SearchCriteria, options?: any): AxiosPromise<NotificationMessagePagination> {
            return localVarFp.notificationsMessagesStatusSearchPost(status, searchCriteria, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * 
     * @param {DeviceRegistration} [deviceRegistration] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public notificationsDeviceDeregisterPost(deviceRegistration?: DeviceRegistration, options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).notificationsDeviceDeregisterPost(deviceRegistration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeviceRegistration} [deviceRegistration] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public notificationsDeviceRegisterAnonymousPost(deviceRegistration?: DeviceRegistration, options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).notificationsDeviceRegisterAnonymousPost(deviceRegistration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeviceRegistration} [deviceRegistration] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public notificationsDeviceRegisterPost(deviceRegistration?: DeviceRegistration, options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).notificationsDeviceRegisterPost(deviceRegistration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {NotificationActionStatusUpdateRequest} [notificationActionStatusUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public notificationsMessagesIdActionStatusPost(id: string, notificationActionStatusUpdateRequest?: NotificationActionStatusUpdateRequest, options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).notificationsMessagesIdActionStatusPost(id, notificationActionStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {NotificationInboxStatusUpdateRequest} [notificationInboxStatusUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public notificationsMessagesIdInboxStatusPost(id: string, notificationInboxStatusUpdateRequest?: NotificationInboxStatusUpdateRequest, options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).notificationsMessagesIdInboxStatusPost(id, notificationInboxStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationStatus} status 
     * @param {SearchCriteria} [searchCriteria] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public notificationsMessagesStatusSearchPost(status: NotificationStatus, searchCriteria?: SearchCriteria, options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).notificationsMessagesStatusSearchPost(status, searchCriteria, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ObservationApi - axios parameter creator
 * @export
 */
export const ObservationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsMeasuringgroupsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/observations/measuringgroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {ObservationSubmissionChartRequest} [observationSubmissionChartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsChartvaluesPost: async (measuringGroup?: string, observationSubmissionChartRequest?: ObservationSubmissionChartRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/observations/submissions/chartvalues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (measuringGroup !== undefined) {
                localVarQueryParameter['measuringGroup'] = measuringGroup;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(observationSubmissionChartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsIdOutcomesGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('observationsSubmissionsIdOutcomesGet', 'id', id)
            const localVarPath = `/observations/submissions/{id}/outcomes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SurveySubmissionRequest} [surveySubmissionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsIdSurveysPost: async (id: string, surveySubmissionRequest?: SurveySubmissionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('observationsSubmissionsIdSurveysPost', 'id', id)
            const localVarPath = `/observations/submissions/{id}/surveys`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveySubmissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Language} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsIdSurveysRequiredGet: async (id: string, language?: Language, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('observationsSubmissionsIdSurveysRequiredGet', 'id', id)
            const localVarPath = `/observations/submissions/{id}/surveys/required`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsLatestGet: async (measuringGroup?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/observations/submissions/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (measuringGroup !== undefined) {
                localVarQueryParameter['measuringGroup'] = measuringGroup;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ObservationSubmissionSaveRequest} [observationSubmissionSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsPost: async (observationSubmissionSaveRequest?: ObservationSubmissionSaveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/observations/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(observationSubmissionSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {ObservationSubmissionSearchRequest} [observationSubmissionSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsSearchPost: async (measuringGroup?: string, observationSubmissionSearchRequest?: ObservationSubmissionSearchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/observations/submissions/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (measuringGroup !== undefined) {
                localVarQueryParameter['measuringGroup'] = measuringGroup;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(observationSubmissionSearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {ObservationSubmissionStatisticRequest} [observationSubmissionStatisticRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsStatisticsPost: async (measuringGroup?: string, observationSubmissionStatisticRequest?: ObservationSubmissionStatisticRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/observations/submissions/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (measuringGroup !== undefined) {
                localVarQueryParameter['measuringGroup'] = measuringGroup;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(observationSubmissionStatisticRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsThresholdsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/observations/thresholds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObservationApi - functional programming interface
 * @export
 */
export const ObservationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObservationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async observationsMeasuringgroupsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeasuringGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.observationsMeasuringgroupsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {ObservationSubmissionChartRequest} [observationSubmissionChartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async observationsSubmissionsChartvaluesPost(measuringGroup?: string, observationSubmissionChartRequest?: ObservationSubmissionChartRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ObservationSubmissionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.observationsSubmissionsChartvaluesPost(measuringGroup, observationSubmissionChartRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async observationsSubmissionsIdOutcomesGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObservationSubmissionOutcome>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.observationsSubmissionsIdOutcomesGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {SurveySubmissionRequest} [surveySubmissionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async observationsSubmissionsIdSurveysPost(id: string, surveySubmissionRequest?: SurveySubmissionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SurveySubmissionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.observationsSubmissionsIdSurveysPost(id, surveySubmissionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {Language} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async observationsSubmissionsIdSurveysRequiredGet(id: string, language?: Language, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.observationsSubmissionsIdSurveysRequiredGet(id, language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async observationsSubmissionsLatestGet(measuringGroup?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObservationSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.observationsSubmissionsLatestGet(measuringGroup, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ObservationSubmissionSaveRequest} [observationSubmissionSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async observationsSubmissionsPost(observationSubmissionSaveRequest?: ObservationSubmissionSaveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObservationSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.observationsSubmissionsPost(observationSubmissionSaveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {ObservationSubmissionSearchRequest} [observationSubmissionSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async observationsSubmissionsSearchPost(measuringGroup?: string, observationSubmissionSearchRequest?: ObservationSubmissionSearchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObservationSubmissionResponsePagination>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.observationsSubmissionsSearchPost(measuringGroup, observationSubmissionSearchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {ObservationSubmissionStatisticRequest} [observationSubmissionStatisticRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async observationsSubmissionsStatisticsPost(measuringGroup?: string, observationSubmissionStatisticRequest?: ObservationSubmissionStatisticRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ObservationSubmissionStatisticResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.observationsSubmissionsStatisticsPost(measuringGroup, observationSubmissionStatisticRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async observationsThresholdsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThresholdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.observationsThresholdsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ObservationApi - factory interface
 * @export
 */
export const ObservationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObservationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsMeasuringgroupsGet(options?: any): AxiosPromise<Array<MeasuringGroupResponse>> {
            return localVarFp.observationsMeasuringgroupsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {ObservationSubmissionChartRequest} [observationSubmissionChartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsChartvaluesPost(measuringGroup?: string, observationSubmissionChartRequest?: ObservationSubmissionChartRequest, options?: any): AxiosPromise<Array<ObservationSubmissionResponse>> {
            return localVarFp.observationsSubmissionsChartvaluesPost(measuringGroup, observationSubmissionChartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsIdOutcomesGet(id: string, options?: any): AxiosPromise<ObservationSubmissionOutcome> {
            return localVarFp.observationsSubmissionsIdOutcomesGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {SurveySubmissionRequest} [surveySubmissionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsIdSurveysPost(id: string, surveySubmissionRequest?: SurveySubmissionRequest, options?: any): AxiosPromise<Array<SurveySubmissionResponse>> {
            return localVarFp.observationsSubmissionsIdSurveysPost(id, surveySubmissionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {Language} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsIdSurveysRequiredGet(id: string, language?: Language, options?: any): AxiosPromise<SurveyTemplateResponse> {
            return localVarFp.observationsSubmissionsIdSurveysRequiredGet(id, language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsLatestGet(measuringGroup?: string, options?: any): AxiosPromise<ObservationSubmissionResponse> {
            return localVarFp.observationsSubmissionsLatestGet(measuringGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ObservationSubmissionSaveRequest} [observationSubmissionSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsPost(observationSubmissionSaveRequest?: ObservationSubmissionSaveRequest, options?: any): AxiosPromise<ObservationSubmissionResponse> {
            return localVarFp.observationsSubmissionsPost(observationSubmissionSaveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {ObservationSubmissionSearchRequest} [observationSubmissionSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsSearchPost(measuringGroup?: string, observationSubmissionSearchRequest?: ObservationSubmissionSearchRequest, options?: any): AxiosPromise<ObservationSubmissionResponsePagination> {
            return localVarFp.observationsSubmissionsSearchPost(measuringGroup, observationSubmissionSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [measuringGroup] 
         * @param {ObservationSubmissionStatisticRequest} [observationSubmissionStatisticRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsSubmissionsStatisticsPost(measuringGroup?: string, observationSubmissionStatisticRequest?: ObservationSubmissionStatisticRequest, options?: any): AxiosPromise<Array<ObservationSubmissionStatisticResponse>> {
            return localVarFp.observationsSubmissionsStatisticsPost(measuringGroup, observationSubmissionStatisticRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        observationsThresholdsGet(options?: any): AxiosPromise<ThresholdResponse> {
            return localVarFp.observationsThresholdsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObservationApi - object-oriented interface
 * @export
 * @class ObservationApi
 * @extends {BaseAPI}
 */
export class ObservationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObservationApi
     */
    public observationsMeasuringgroupsGet(options?: AxiosRequestConfig) {
        return ObservationApiFp(this.configuration).observationsMeasuringgroupsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [measuringGroup] 
     * @param {ObservationSubmissionChartRequest} [observationSubmissionChartRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObservationApi
     */
    public observationsSubmissionsChartvaluesPost(measuringGroup?: string, observationSubmissionChartRequest?: ObservationSubmissionChartRequest, options?: AxiosRequestConfig) {
        return ObservationApiFp(this.configuration).observationsSubmissionsChartvaluesPost(measuringGroup, observationSubmissionChartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObservationApi
     */
    public observationsSubmissionsIdOutcomesGet(id: string, options?: AxiosRequestConfig) {
        return ObservationApiFp(this.configuration).observationsSubmissionsIdOutcomesGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {SurveySubmissionRequest} [surveySubmissionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObservationApi
     */
    public observationsSubmissionsIdSurveysPost(id: string, surveySubmissionRequest?: SurveySubmissionRequest, options?: AxiosRequestConfig) {
        return ObservationApiFp(this.configuration).observationsSubmissionsIdSurveysPost(id, surveySubmissionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {Language} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObservationApi
     */
    public observationsSubmissionsIdSurveysRequiredGet(id: string, language?: Language, options?: AxiosRequestConfig) {
        return ObservationApiFp(this.configuration).observationsSubmissionsIdSurveysRequiredGet(id, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [measuringGroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObservationApi
     */
    public observationsSubmissionsLatestGet(measuringGroup?: string, options?: AxiosRequestConfig) {
        return ObservationApiFp(this.configuration).observationsSubmissionsLatestGet(measuringGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ObservationSubmissionSaveRequest} [observationSubmissionSaveRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObservationApi
     */
    public observationsSubmissionsPost(observationSubmissionSaveRequest?: ObservationSubmissionSaveRequest, options?: AxiosRequestConfig) {
        return ObservationApiFp(this.configuration).observationsSubmissionsPost(observationSubmissionSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [measuringGroup] 
     * @param {ObservationSubmissionSearchRequest} [observationSubmissionSearchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObservationApi
     */
    public observationsSubmissionsSearchPost(measuringGroup?: string, observationSubmissionSearchRequest?: ObservationSubmissionSearchRequest, options?: AxiosRequestConfig) {
        return ObservationApiFp(this.configuration).observationsSubmissionsSearchPost(measuringGroup, observationSubmissionSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [measuringGroup] 
     * @param {ObservationSubmissionStatisticRequest} [observationSubmissionStatisticRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObservationApi
     */
    public observationsSubmissionsStatisticsPost(measuringGroup?: string, observationSubmissionStatisticRequest?: ObservationSubmissionStatisticRequest, options?: AxiosRequestConfig) {
        return ObservationApiFp(this.configuration).observationsSubmissionsStatisticsPost(measuringGroup, observationSubmissionStatisticRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObservationApi
     */
    public observationsThresholdsGet(options?: AxiosRequestConfig) {
        return ObservationApiFp(this.configuration).observationsThresholdsGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReminderApi - axios parameter creator
 * @export
 */
export const ReminderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindersGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReminderSaveRequest} [reminderSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindersPost: async (reminderSaveRequest?: ReminderSaveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reminders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reminderSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReminderApi - functional programming interface
 * @export
 */
export const ReminderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReminderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remindersGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReminderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remindersGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReminderSaveRequest} [reminderSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remindersPost(reminderSaveRequest?: ReminderSaveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReminderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remindersPost(reminderSaveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReminderApi - factory interface
 * @export
 */
export const ReminderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReminderApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindersGet(options?: any): AxiosPromise<ReminderResponse> {
            return localVarFp.remindersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReminderSaveRequest} [reminderSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remindersPost(reminderSaveRequest?: ReminderSaveRequest, options?: any): AxiosPromise<ReminderResponse> {
            return localVarFp.remindersPost(reminderSaveRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReminderApi - object-oriented interface
 * @export
 * @class ReminderApi
 * @extends {BaseAPI}
 */
export class ReminderApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReminderApi
     */
    public remindersGet(options?: AxiosRequestConfig) {
        return ReminderApiFp(this.configuration).remindersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReminderSaveRequest} [reminderSaveRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReminderApi
     */
    public remindersPost(reminderSaveRequest?: ReminderSaveRequest, options?: AxiosRequestConfig) {
        return ReminderApiFp(this.configuration).remindersPost(reminderSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserProfileApi - axios parameter creator
 * @export
 */
export const UserProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ConsentAgreementRequest} [consentAgreementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersConsentsAgreePost: async (consentAgreementRequest?: ConsentAgreementRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/consents/agree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentAgreementRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersConsentsCheckGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/consents/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersConsentsPendingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/consents/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersMeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Language} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersSettingLanguagePost: async (language?: Language, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/setting/language`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserProfileApi - functional programming interface
 * @export
 */
export const UserProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ConsentAgreementRequest} [consentAgreementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersConsentsAgreePost(consentAgreementRequest?: ConsentAgreementRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersConsentsAgreePost(consentAgreementRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersConsentsCheckGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersConsentsCheckGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersConsentsPendingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConsentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersConsentsPendingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersMeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsumerUserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersMeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Language} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersSettingLanguagePost(language?: Language, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersSettingLanguagePost(language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserProfileApi - factory interface
 * @export
 */
export const UserProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserProfileApiFp(configuration)
    return {
        /**
         * 
         * @param {ConsentAgreementRequest} [consentAgreementRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersConsentsAgreePost(consentAgreementRequest?: ConsentAgreementRequest, options?: any): AxiosPromise<ConsentCheckResponse> {
            return localVarFp.usersConsentsAgreePost(consentAgreementRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersConsentsCheckGet(options?: any): AxiosPromise<ConsentCheckResponse> {
            return localVarFp.usersConsentsCheckGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersConsentsPendingGet(options?: any): AxiosPromise<Array<ConsentResponse>> {
            return localVarFp.usersConsentsPendingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersMeGet(options?: any): AxiosPromise<ConsumerUserProfileResponse> {
            return localVarFp.usersMeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Language} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersSettingLanguagePost(language?: Language, options?: any): AxiosPromise<boolean> {
            return localVarFp.usersSettingLanguagePost(language, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserProfileApi - object-oriented interface
 * @export
 * @class UserProfileApi
 * @extends {BaseAPI}
 */
export class UserProfileApi extends BaseAPI {
    /**
     * 
     * @param {ConsentAgreementRequest} [consentAgreementRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public usersConsentsAgreePost(consentAgreementRequest?: ConsentAgreementRequest, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).usersConsentsAgreePost(consentAgreementRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public usersConsentsCheckGet(options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).usersConsentsCheckGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public usersConsentsPendingGet(options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).usersConsentsPendingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public usersMeGet(options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).usersMeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Language} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileApi
     */
    public usersSettingLanguagePost(language?: Language, options?: AxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).usersSettingLanguagePost(language, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VersionsApi - axios parameter creator
 * @export
 */
export const VersionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/app/Versions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VersionsApi - functional programming interface
 * @export
 */
export const VersionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VersionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appVersionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appVersionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VersionsApi - factory interface
 * @export
 */
export const VersionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VersionsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionsGet(options?: any): AxiosPromise<AppVersion> {
            return localVarFp.appVersionsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VersionsApi - object-oriented interface
 * @export
 * @class VersionsApi
 * @extends {BaseAPI}
 */
export class VersionsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionsApi
     */
    public appVersionsGet(options?: AxiosRequestConfig) {
        return VersionsApiFp(this.configuration).appVersionsGet(options).then((request) => request(this.axios, this.basePath));
    }
}


